




















import { defineComponent, PropType } from '@vue/composition-api';
import { Year, Month, Week } from '@oare/types';

export default defineComponent({
  name: 'PeriodMonth',
  props: {
    year: {
      type: Object as PropType<Year>,
      required: true,
    },
    month: {
      type: Object as PropType<Month>,
      required: true,
    },
  },
  
  setup() {
    const dynamicCol = (abbreviation: number) => {
      if (abbreviation < 13) {
        return 2;
      } else {
        return 10;
      }
    };

    return {
      dynamicCol,
    };
  },
});
